<template>
  <div class="pagination-bubble">
    <div class="pagination-bubble__steps">
      <div class="pagination-bubble__step"
           :class="{'active': activeStep === step}"
           v-for="(step, index) in steps"
           :key="index">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pagination-bubble",
    props: {
      activeStep: {type: Number, required: true},
      steps: {type: Number, required: true}
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .pagination-bubble {
    @extend %layout--flex-row-center-xy;
  }

  .pagination-bubble__steps {
    @extend %layout--flex-row-center-x-spaced;
  }

  .pagination-bubble__step {
    @include border-radius(radius(circle));
    background: color(gray-200);
    width: 10px;
    height: 10px;

    &.active {
      background: color(dodgerBlue);
    }
  }
</style>